import { RichTextElement } from '@kontent-ai/gatsby-components';
import { useTranslation } from 'react-i18next';
import useResolveRichTextInternalLink from '@/components/RichTextBlock/hooks/useResolveRichTextInternalLink';
import { isRichTextValid } from '@/components/RichTextBlock/utils';
import { LegalTextWrap } from './LegalText.styles';
import { type TFunction } from 'i18next';

export interface LegalTextProps {
  richText?: {
    value: string;
    links: {
      codename: string;
      link_id: string;
    }[];
  } | null;
}

const LegalText = ({ richText }: LegalTextProps) => {
  const { t } = useTranslation();
  const resolveRichTextInternalLink = useResolveRichTextInternalLink();
  const isLegalTextValid = isRichTextValid(richText?.value);

  return (
    <LegalTextWrap>
      {isLegalTextValid && (
        <RichTextElement
          links={richText.links}
          value={richText.value}
          resolveLink={resolveRichTextInternalLink}
        />
      )}
      {isLegalTextValid && ' '}
      {GoogleRecaptchaLegalText(t)}
    </LegalTextWrap>
  );
};

const GoogleRecaptchaLegalText = (t: TFunction<'translation', undefined>) => (
  <p>
    {t('recaptchaLegal.This site is protected by reCAPTCHA and the Google')}{' '}
    <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
      {t('recaptchaLegal.Privacy Policy')}
    </a>{' '}
    {t('recaptchaLegal.and')}{' '}
    <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">
      {t('recaptchaLegal.Terms of Service')}
    </a>{' '}
    {t('recaptchaLegal.apply')}
  </p>
);

export default LegalText;
